<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-08-10 18:18:26
--> 
<template>
  <div>
    <staffGroup></staffGroup>
  </div>
</template> 
 
<script>
import staffGroup from './staffGroup'
export default {
  components: {
    staffGroup
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>